import { Box, Flex, Heading, Link, SimpleGrid, Text } from "@chakra-ui/react";
import React from "react";
import WaitTimesTable from "./WaitTimesTable";

const Card = ({ children, ...props }) => (
  <Flex
    width="200px"
    height="200px"
    justifyContent="center"
    alignItems="center"
    bg="white"
    borderRadius="md"
    as={Link}
    {...props}
  >
    {children}
  </Flex>
);

const WaitTimesProgramPicker = () => {
  return (
    <Flex
      textAlign="center"
      flexDir="column"
      justifyContent="center"
      alignItems="center"
      minH="80vh"
    >
      <Heading as="h1" size="lg">
        Choose your program
      </Heading>
      <SimpleGrid
        alignItems="center"
        justifyContent="center"
        mt={{ base: "10", lg: "24" }}
        columns={{ base: 1, md: 3 }}
        spacing={{ base: "6", lg: "3" }}
      >
        <Card href="/locations/global-entry">
          <Text>Global Entry</Text>
        </Card>
        <Card href="/locations/nexus">
          <Text>NEXUS</Text>
        </Card>
        <Card href="/locations/sentri">
          <Text>SENTRI</Text>
        </Card>
      </SimpleGrid>
    </Flex>
  );
};

export default WaitTimesProgramPicker;
